/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { EmailEditor } from '@nile/banyan/src/Components/Editors';
import {
  AppContext,
  getHeaderValue,
  getObjectValueCount,
  getTranslatedText,
  Loader,
  toast,
  COLOR_MAP,
  useIsAuthorisedHook,
  Splitter,
  HiddenAction,
  NoDataCard,
  T2,
  Editor,
  EventEmitter,
  ActionButtons,
  fetchApi,
  AIComponent,
  getAIRephraseKeys,
  getConversationOrder,
  scrollToTop,
  scrollToBottom,
  reactbellchatScrollBottom,
  reactbellchatScrollTop,
  COMMON_CONSTANTS,
  AccessControl,
  SearchableEmailSelect
} from '@nile/components';
import MultipleNamesHandler from '@nile/components/src/Pebbles/multipleNamesHandler';
import {
  APPLY_AI_PROMPT,
  AccountClient,
  GET_VENDOR_CONVERSATION_REPLY_RECIEPIENTS
} from '@nile/graphql';
import Tippy from '@tippyjs/react';
import envConfig from '@nile/home/src/Config/env';
import dompurify from 'dompurify';
import { EditorState } from 'draft-js';
import { cloneDeep, isEqual, pick } from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Tooltip } from 'react-tippy';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ChatFeed } from 'react-bell-chat';
import { SideConversationBubble } from '@nile/mangifera/src/Components/Chat';
import { Button, ButtonGroup, Spinner } from '@superops/ui-design-system';
import { FromMailBoxSelector } from '../NewSideConversation';
import SideConversationTemplateButton from '../SideConversationTemplateButton';
import { dompurifier, getAIPrompts } from '@nile/components/src/Utils/helpers';
import { GET_DEFAULT_SIDE_CONVERSATION_REPLY_TEMPLATE } from '@nile/graphql/src/Query/ticket';
import useSideConversationActions from '@nile/components/src/Components/Conversations/sideConversationActionsHook.tsx';
import { useGlobalChatHook } from '@nile/components/src/Components/GlobalChatHook';

const ComposeSectionHolder = styled.div`
  margin: 20px;
  padding: 10px;
  background: var(--sops-white-to-grey-bg);
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  padding-bottom: 10px;
  position: relative;
  // max-height: calc(100% - 30px);
  box-shadow: 0px 2.32836px 25.6119px rgb(0 0 0 / 5%);
`;

const Wrapper = styled.div`
  border: 1px solid #ececec;
  border-top: 0px transparent;
  background-size: 360px;
  background-color: #f9f9ff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-image: url(${envConfig.imageRoot}svg/chatBg.svg);
  .message-content {
    width: 100%;
    overflow: scroll;
    margin-top: 10px;
    word-break: break-word;

    img,
    table {
      max-width: 100%;
      overflow: auto;
    }
  }
`;

const ReplyThreadWrapper = styled.div`
  display: flex;
  min-height: 200px;
  flex-direction: column;
  background: transparent;
  overflow: auto;
  .rdw-editor-wrapper {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
    border: 1px solid #ececec;
  }
  .action-buttons .Polaris-Button--plain {
    margin-left: auto;
  }
`;

const Convos = styled.div`
  flex-grow: 1;
  // padding: 36px 20px 20px;

  .react-bell-chat__chat-panel {
    height: 100%;
  }
`;

const EditorHolder = styled.div`
  max-height: ${(props) => `calc(100% - ${props.maxHeight})`};
  #quill-rt-editor {
    height: 100%;
    .quill {
      // min-height: 200px;
      max-height: calc(100% - 45px);
      overflow: auto;
      .ql-container {
        border: none;
        // min-height: inherit;
        .ql-editor {
          min-height: 200px;
        }
      }
    }
    .ql-toolbar {
      border: none;
    }
  }
  .ql-editor {
    max-height: 300px;
  }
`;

const ActionToolbarContainer = styled.div`
  width: 95%;
  padding: 16px 0;
  max-width: calc(100% - 30px);
  border-radius: 30px;
  background: #ffffff;
  margin: 0 auto 14px;
  border: 1px solid #ececec;
  justify-content: space-evenly;
  .Superops-Button__Text {
    margin-left: 10px !important;
  }
  .conversationReply {
    .Superops-Button {
      width: 100%;
    }
    .Superops-Button__Text {
      text-overflow: ellipsis;
      overflow: hidden;
      line-break: anywhere;
      white-space: nowrap;
    }
  }
`;
const Label = styled.span`
  color: #000000;
  opacity: 0.6;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

const EmptyStateHolder = styled.div.attrs({
  className: 'flex center jcenter'
})`
  height: calc(100% - 108px);
  overflow: auto;
`;

const EmailStatus = styled.span`
  padding: 0 8px;
  color: #ff0055;
  svg {
    margin-right: 8px;
  }
`;

const ToolTipContainer = styled.div`
  padding: 5px 10px;
`;

const SpinnerContainer = styled.div`
  .Superops-Spinner {
    display: flex;

    svg {
      width: 12px;
      height: 12px;
      fill: #000000;
    }
  }
`;

const ActionsButtons = styled(ActionButtons)`
  ${(props) => !props.absolute && 'margin-left: auto;'}
`;

function ActionToolbar(props) {
  const {
    onClick,
    emailSignature,
    toUser,
    createNewSideConversation,
    modalOnly,
    toggleNewSideConversation,
    loading,
    replyDisabled,
    isNewSideConversationDisabled
  } = props;
  return (
    <ActionToolbarContainer className="fx" id="actionToolbarHolder-2">
      <div className="fx center fx2 actr jctr">
        {createNewSideConversation && (
          <>
            {modalOnly ? (
              <Button
                plain
                onClick={toggleNewSideConversation}
                loading={props?.newSideConversationLoading}
                icon={<SVGIcon color={COLOR_MAP.blue} name="Helpcenter" />}
                disabled={isNewSideConversationDisabled}
              >
                <FormattedMessage id="app.sideConversation.create.new" />
              </Button>
            ) : (
              <>{createNewSideConversation(emailSignature)}</>
            )}
          </>
        )}
      </div>
      <Splitter className="ml-12" color={COLOR_MAP.grey} />
      {toUser.email && (
        <div className="conversationReply ml-12 fx2">
          <Button
            plain
            onClick={onClick}
            icon={<SVGIcon color={COLOR_MAP.blue} name="Reply" />}
            loading={loading}
            disabled={replyDisabled}
          >
            <Tooltip
              inertia
              delay={300}
              theme="dark"
              duration={250}
              animation="shift"
              animateFill={false}
              trigger="mouseenter"
              position="bottom-start"
              html={toUser?.email || ''}
            >
              <FormattedMessage id="app.sideConversation.reply.to" />
              {toUser.email || ''}
            </Tooltip>
          </Button>
        </div>
      )}
    </ActionToolbarContainer>
  );
}

const ComposeNew = (props) => {
  const {
    module,
    parentConversationId,
    workItem,
    toUser,
    emailSignature,
    toggleNewSideConversation,
    isNewSideConversationDisabled,
    newSideConversationLoading
  } = props;
  const intl = useIntl();
  const { openChatPopup, loading } = useSideConversationActions({
    workItem,
    module,
    conversationId: parentConversationId
  });

  const { getGlobalConversations } = useGlobalChatHook();

  const globalConversations = getGlobalConversations();

  const [disabled, setDisabled] = useState(false);

  const handleOnClick = () => {
    openChatPopup();
  };

  useEffect(() => {
    const currentTicketConversationData = globalConversations?.find(
      (conversation) =>
        conversation?.data?.conversationId === parentConversationId
    );
    if (currentTicketConversationData) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [globalConversations]);

  return (
    <ActionToolbar
      loading={loading}
      intl={intl}
      onClick={handleOnClick}
      emailSignature={emailSignature}
      createNewSideConversation
      toUser={toUser}
      modalOnly
      toggleNewSideConversation={toggleNewSideConversation}
      replyDisabled={disabled}
      isNewSideConversationDisabled={isNewSideConversationDisabled}
      newSideConversationLoading={newSideConversationLoading || loading}
    />
  );
};

function ChatThreadContainer(props) {
  const flags = useFlags();
  const {
    intl,
    isMSP,
    module,
    workItemId,
    responseKey,
    query,
    updateReadStatusApi,
    createConversationQuery,
    currentReplyThread,
    clientId,
    createNewSideConversation,
    readOnly,
    modalOnly,
    toggleNewSideConversation,
    backgroundThreadConversation,
    sentMessageData,
    containerRef,
    conversationToBeOpened,
    conversation,
    preventCacheUpdate = true,
    isNewSideConversationDisabled,
    newSideConversationLoading
  } = props;

  const editorRef = useRef();
  const [conversations, setConversations] = useState([]);
  const [listInfo, setListInfo] = useState(null);
  const appContext = useContext(AppContext);
  const isEditAuthorised = !!createNewSideConversation;
  const conversationUXFlag = module === 'TICKET' && flags?.ticketConversationUx;
  const { company } = appContext;

  // value from user preferred conversation order
  const conversationOrder = getConversationOrder() || 'ASC';

  const conversationcontainerRef = React.createRef(
    currentReplyThread?.conversationId
  );
  const editorContainerRef = useRef();
  const [createConversation] = useMutation(createConversationQuery, {
    client: AccountClient
  });
  // const [allConversationsLoading, setAllConversationsLoading] = useState(true);
  const [state, setState] = useState({
    editorState: EditorState.createEmpty(),
    template: {
      name: '',
      content: '',
      placeholdersUsed: '',
      attachments: [],
      inlineImages: []
    },
    toUsers: [],
    content: '',
    parentConversationId:
      currentReplyThread?.parentConversation?.conversationId ||
      currentReplyThread?.conversationId
  });
  const [emailSignature, setEmailSignature] = useState(null);
  const [allToUsers, setToUsers] = useState([]);
  const [allCCUsers, setCCUsers] = useState([]);
  const [bccUsers, setBCCUsers] = useState([]);

  const [showCC, setShowCC] = useState(false);
  const [showBCC, setShowBCC] = useState(false);
  const [compose, setCompose] = useState(props.noNewConversation || false);
  const [mailBoxes, setMailBoxes] = useState([]);
  const [selectedMailBox, setSelectedMailBox] = useState(null);
  const [isImageUploading, setIsImageUploading] = useState(false);

  const [editorWidthIsSmall, setEditorWidthIsSmall] = useState(false);

  let timer = null;

  // should be useMutation
  const [updateReadStatus] = useMutation(updateReadStatusApi, {
    client: AccountClient,
    update(cache, { data }) {
      // if (data && props.refetchParent) props.refetchParent();
    }
  });

  const [
    getSideConversationTemplate,
    {
      loading: sideConversationTemplateLoading,
      error: sideConversationTemplateError
    }
  ] = useLazyQuery(GET_DEFAULT_SIDE_CONVERSATION_REPLY_TEMPLATE, {
    client: AccountClient,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE
  });

  const updateTemplateContent = (content) => {
    if (content) {
      setState((prevState) => ({
        ...prevState,
        template: {
          ...prevState.template,
          content: content
        }
      }));

      if (editorRef.current?.updateEditorContent) {
        editorRef.current.updateEditorContent(content);
      }
    }
  };

  const getSideConversationTemplateData = async (params) => {
    const mailbox = params?.mailbox;
    const emailSignatureData = params?.emailSignature;

    // Get mailbox and emailSignatureData
    // Set template content based on side conversation template and email signature
    const sideConversationTemplateVariables = {
      input: {
        template: null,
        workItem: {
          workId: workItemId,
          module: module
        },
        mailbox: mailbox?.boxId
          ? {
              boxId: mailbox?.boxId
            }
          : null
      }
    };

    let result;
    try {
      result = await getSideConversationTemplate({
        variables: sideConversationTemplateVariables
      });
      const templateContent =
        result?.data?.getVendorConversationContentFromTemplate?.content;
      if (templateContent) {
        updateTemplateContent(templateContent);
      } else if (emailSignatureData) {
        updateTemplateContent(emailSignatureData);
      }
    } catch (error) {
      console.error('Error fetching side conversation template:', error);
      if (emailSignatureData) {
        updateTemplateContent(emailSignatureData);
      }
    }
  };

  const [
    getVendorReplyRecipients,
    { data: replyRecipients, loading: vendorConversationReplyRecipientsLoading }
  ] = useLazyQuery(GET_VENDOR_CONVERSATION_REPLY_RECIEPIENTS, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    variables: {
      input: {
        workItem: {
          workId: workItemId,
          module: module
        },
        conversation: {
          conversationId: currentReplyThread?.conversationId
        }
      }
    },
    onCompleted(res) {
      if (res.getVendorConversationReplyRecipients) {
        const replyRecepients = res.getVendorConversationReplyRecipients;
        if (replyRecepients?.to) {
          setToUsers(replyRecepients.to);
        }
        if (replyRecepients?.cc) {
          setCCUsers(replyRecepients.cc);
        }
        if (replyRecepients?.mailboxes) {
          setMailBoxes(replyRecepients.mailboxes);
        }
        if (replyRecepients?.selectedMailbox) {
          setSelectedMailBox(replyRecepients.selectedMailbox);
        }
        let emailSignatureContent = null;
        if (replyRecepients?.selectedMailbox?.emailSignature) {
          const mailBoxEmailSignature =
            replyRecepients?.selectedMailbox?.emailSignature;
          setEmailSignature(mailBoxEmailSignature);
          emailSignatureContent = `${
            mailBoxEmailSignature
              ? `<p><br></p><p><br></p>${mailBoxEmailSignature}`
              : ''
          }`;
        }
        getSideConversationTemplateData({
          mailbox: replyRecepients.selectedMailbox,
          emailSignature: emailSignatureContent || null
        });
      }
    }
  });

  useEffect(() => {
    if (
      currentReplyThread?.parentConversationId ||
      currentReplyThread?.conversationId
    ) {
      // This API will give the mailbox data and signature
      // Once we get them we'll call side conversation template API and construct template
      getVendorReplyRecipients();
      setState((prevState) => ({
        ...prevState,
        parentConversationId:
          currentReplyThread?.parentConversationId ||
          currentReplyThread?.conversationId
      }));
    } else {
      // Construct side conversation template
      getSideConversationTemplateData();
    }

    if (
      currentReplyThread &&
      !currentReplyThread?.opened &&
      currentReplyThread.latestReply.type === 'VENDOR_EMAIL'
    ) {
      updateReadStatus({
        variables: {
          input: {
            conversation: {
              conversationId: currentReplyThread?.conversationId
            },
            workItem: { workId: workItemId, module: module },
            status: true
          }
        }
      });
    }
  }, [currentReplyThread]);
  const loggedInUser = appContext.user;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    //only parent container scroll to bottom happens for recent last items,
    //should not happens whenever conversations updated
    if (
      conversations.length > 0 &&
      conversation?.conversationId === conversationToBeOpened
    ) {
      if (conversationOrder === 'ASC') {
        scrollToBottom(containerRef);
      } else {
        scrollToTop(containerRef);
      }
    }
  }, [conversationToBeOpened, conversations]);

  useEffect(() => {
    if (conversations.length > 0) {
      if (conversationOrder === 'ASC') {
        reactbellchatScrollBottom(conversationcontainerRef);
      } else {
        reactbellchatScrollTop(conversationcontainerRef);
      }
    }
  }, [conversations]);

  useEffect(() => {
    setState({
      editorState: EditorState.createEmpty(),
      template: {
        name: '',
        content: emailSignature
          ? `<p><br></p><p><br></p>${emailSignature}`
          : '',
        placeholdersUsed: '',
        attachments: [],
        inlineImages: []
      },
      toUsers: [],
      content: '',
      parentConversationId:
        currentReplyThread?.parentConversation?.conversationId ||
        currentReplyThread?.conversationId
    });
    setShowCC(false);
    setShowBCC(false);
    setCCUsers([]);
    setBCCUsers([]);
  }, [clientId]);

  function handleConversationData(response) {
    const conversationList = response[responseKey];
    const currentConversationList = cloneDeep(conversations);
    const newConversationList = conversationList?.conversations;
    const updatedData = [];
    newConversationList.forEach((conversationData) => {
      const prevData = currentConversationList.find(
        (prevConv) =>
          prevConv?.conversationId === conversationData?.conversationId
      );

      // If no previous data exists or statuses match, use new data
      if (
        !prevData ||
        prevData.outgoingMailStatus === conversationData.outgoingMailStatus
      ) {
        updatedData.push(conversationData);
      }
      // Handle the race condition - don't override SUCCESS with PROGRESS
      else if (
        (conversationData.outgoingMailStatus === 'PROGRESS' ||
          conversationData?.outgoingMailFailureReason === 'IN_QUEUE') &&
        prevData.outgoingMailStatus === 'SUCCESS'
      ) {
        updatedData.push(prevData);
      }
      // For all other status changes, use the new data
      else {
        updatedData.push(conversationData);
      }
    });
    setConversations(updatedData || []);
    if (conversationList?.listInfo) {
      setListInfo(conversationList?.listInfo);
    }
  }

  const handlePageResize = () => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      setEditorWidthIsSmall(
        editorContainerRef?.current?.getBoundingClientRect()?.width < 710
      );
    }, 1000);
  };

  const {
    loading: allConversationsLoading,
    data: allConversations,
    error: allConversationError,
    refetch
  } = useQuery(query, {
    fetchPolicy: 'cache-and-network',
    skip: !currentReplyThread,
    client: AccountClient,
    variables: {
      input: {
        module: module,
        listInfo: {
          condition: {
            joinOperator: 'AND',
            operands: [
              {
                joinOperator: 'OR',
                operands: [
                  {
                    joinOperator: 'AND',
                    operands: [
                      {
                        attribute: 'parentConversationId',
                        operator: 'is',
                        value: state.parentConversationId
                      }
                    ]
                  },
                  {
                    joinOperator: 'AND',
                    operands: [
                      {
                        attribute: 'conversationId',
                        operator: 'is',
                        value: currentReplyThread?.conversationId
                      }
                    ]
                  }
                ]
              },
              {
                joinOperator: 'AND',
                operands: [
                  {
                    attribute: 'workItem.workId',
                    operator: 'is',
                    value: workItemId
                  }
                ]
              }
            ]
          },
          sort: [
            {
              attribute: 'time',
              order: conversationOrder
            }
          ]
        }
      }
    }
  });

  const updateTemplate = (obj) => {
    setState((prevState) => ({
      ...prevState,
      template: { ...prevState.template, ...obj }
    }));
  };

  const handleFileAttachments = (files, callback) => {
    const formData = new FormData();
    // formData.append('files', files);
    files.forEach((file, idx) => {
      formData.append(`files`, file);
    });
    if (workItemId && module) {
      formData.append(
        'details',
        JSON.stringify({
          workItem: {
            workId: workItemId,
            module: module
          }
        })
      );
    }
    formData.append('module', 'VENDOR_CONVERSATION_ATTACHMENT');

    const requestOptions = {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: getHeaderValue()
    };
    fetchApi(`${envConfig.fileRoot}/upload`, requestOptions)
      .then((response) => {
        console.log('email template attachment response is ', response);
        return response.json();
      })
      .then((list) => {
        setState((prevState) => ({
          ...prevState,
          template: {
            ...prevState.template,
            attachments: [...prevState.template.attachments, ...list.data]
          }
        }));
        if (callback) {
          callback();
        }
      })
      .catch((err) => {
        console.error('Error:', err);
      });
  };

  const handleAttachmentsDeletion = (fileName) => {
    setState((prevState) => ({
      ...prevState,
      template: {
        ...prevState.template,
        attachments: prevState.template.attachments.filter(
          (item) => item.fileName !== fileName
        )
      }
    }));
  };

  const onRephraseCopy = (content, params) => {
    if (editorRef.current?.FroalaEditorRef) {
      EventEmitter.dispatch('insertEditorContent', dompurifier(content));
    } else {
      EventEmitter.dispatch('replaceEditorContent', dompurifier(content));
    }
  };

  const populateTemplate = (selectedTemplate) => {
    if (selectedTemplate?.subject || selectedTemplate?.name) {
      setState((prevState) => ({
        ...prevState,
        subject: selectedTemplate?.subject || selectedTemplate?.name
      }));
    }

    const templateContent = selectedTemplate?.content
      ? dompurifier(selectedTemplate.content)
      : '';

    // Insert template content at cursor position
    if (templateContent) {
      EventEmitter.dispatch('insertEditorContent', templateContent);
    }

    // Update attachments if provided
    if (selectedTemplate?.attachmentList || selectedTemplate?.attachments) {
      setState((prevState) => ({
        ...prevState,
        template: {
          ...prevState.template,
          attachments: [
            ...(prevState.template?.attachments || []),
            ...(selectedTemplate.attachmentList ||
              selectedTemplate.attachments ||
              [])
          ]
        }
      }));
    }
  };

  const conversationLength =
    allConversations?.[responseKey]?.conversations?.length;

  useEffect(() => {
    if (allConversations?.[responseKey]) {
      handleConversationData(allConversations);
    }
  }, [conversationLength]);

  const updateConversationsFromSocket = (updatedConversation) => {
    console.log(updatedConversation, 'ash:: updatedConversation from socket');
    const updatedConversationList = conversations.map((conversation) => {
      if (
        conversation?.conversationId === updatedConversation?.conversationId
      ) {
        return {
          ...conversation,
          outgoingMailStatus: updatedConversation?.outgoingMailStatus,
          outgoingMailFailureReason:
            updatedConversation?.outgoingMailFailureReason || null
        };
      } else {
        return conversation;
      }
    });

    const variables = {
      input: {
        module: module,
        listInfo: {
          condition: {
            joinOperator: 'AND',
            operands: [
              {
                joinOperator: 'OR',
                operands: [
                  {
                    joinOperator: 'AND',
                    operands: [
                      {
                        attribute: 'parentConversationId',
                        operator: 'is',
                        value:
                          updatedConversation?.parentConversationId ||
                          updatedConversation?.conversationId
                      }
                    ]
                  },
                  {
                    joinOperator: 'AND',
                    operands: [
                      {
                        attribute: 'conversationId',
                        operator: 'is',
                        value:
                          updatedConversation?.parentConversationId ||
                          updatedConversation?.conversationId
                      }
                    ]
                  }
                ]
              },
              {
                joinOperator: 'AND',
                operands: [
                  {
                    attribute: 'workItem.workId',
                    operator: 'is',
                    value: workItemId
                  }
                ]
              }
            ]
          },
          sort: [
            {
              attribute: 'time',
              order: conversationOrder
            }
          ]
        }
      }
    };

    if (preventCacheUpdate) {
      const data = {
        [responseKey]: {
          conversations: updatedConversationList,
          listInfo: listInfo
        }
      };
      handleConversationData(data);
    } else {
      if (listInfo) {
        AccountClient.writeQuery({
          query: query,
          variables: variables,
          data: {
            [responseKey]: {
              conversations: updatedConversationList,
              listInfo: listInfo
            }
          }
        });
      } else {
        AccountClient.writeQuery({
          query: query,
          variables: variables,
          data: {
            [responseKey]: {
              conversations: updatedConversationList
            }
          }
        });
      }
    }
  };

  const composeEmail = (mail, callback) => {
    setLoading(true);

    createConversation({
      variables: {
        input: {
          ...mail,
          sendMail: true,
          workItem: {
            workId: workItemId,
            module: module
          }
        }
      }
    })
      .then((res) => {
        setLoading(false);
        if (!backgroundThreadConversation) {
          refetch().then((updatedData) => {
            // setConversations(
            //   updatedData?.data?.[responseKey]?.conversations || []
            // );
            if (callback)
              callback(updatedData?.data?.[responseKey]?.conversations || []);
          });
        } else {
          const addedConversation = res?.data?.createVendorConversation;
          const updatedConversations = cloneDeep(conversations) || [];
          if (conversationOrder === 'ASC') {
            updatedConversations.push(addedConversation);
            scrollToBottom(containerRef);
          } else {
            updatedConversations.unshift(addedConversation);
            scrollToTop(containerRef);
          }
          setConversations(updatedConversations);
        }

        if (res) {
          if (!backgroundThreadConversation) {
            toast('success', 'app.sideConversation.create.success');
          }
          setState((prevState) => ({
            ...prevState,
            template: {
              ...prevState.template,
              name: '',
              content: emailSignature
                ? `<p><br></p><p><br></p>${emailSignature}`
                : '',
              placeholdersUsed: '',
              attachments: [],
              inlineImages: []
            }
          }));
          getVendorReplyRecipients();
          setCompose(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const getCCUsers = (users, toMap) => {
    return users.filter((el) => !toMap[el.email]);
  };

  const getBccUsers = (users, toMap, ccMap) => {
    return users.filter((el) => !toMap[el.email] && !ccMap[el.email]);
  };

  const aiRephraseKeys = getAIRephraseKeys(intl);

  const resetState = (convos) => {
    setState({
      editorState: EditorState.createEmpty(),
      template: {
        name: '',
        content: emailSignature
          ? `<p><br></p><p><br></p>${emailSignature}`
          : '',
        placeholdersUsed: '',
        attachments: [],
        inlineImages: []
      },
      toUsers: [],
      content: '',
      parentConversationId:
        currentReplyThread?.parentConversation?.conversationId ||
        currentReplyThread?.conversationId
    });
    setShowBCC(false);
    // const allCcUsers = getCCUsersToCarryForward(convos);
    setCCUsers(
      allCCUsers.map((el) => {
        return {
          ...el,
          value: el.email,
          label: el.name || el.email
        };
      })
    );
    if (!allCCUsers.length) setShowCC(false);
    setBCCUsers([]);
  };

  const AIPrompts = getAIPrompts();

  useEffect(() => {
    if (allCCUsers.length && !showCC) setShowCC(true);
  }, [allCCUsers]);

  useEffect(() => {
    EventEmitter.subscribe('imageUploading', setIsImageUploading);

    return () => {
      EventEmitter.unsubscribe('imageUploading');
    };
  }, []);

  useEffect(() => {
    if (compose) {
      window.addEventListener('resize', handlePageResize);

      return () => {
        window.removeEventListener('resize', handlePageResize);
      };
    }
  }, [compose]);

  function mailBoxChangeHandler(mailbox) {
    if (!isEqual(mailbox, selectedMailBox)) {
      setSelectedMailBox(mailbox);
    }
  }

  const composeMail = () => {
    const rawContent = dompurifier(state?.template?.content) || '';
    setLoading(true);
    const allCcUsers = allCCUsers?.length ? allCCUsers : null;
    const allBccUsers = bccUsers?.length ? bccUsers : null;
    const toUserMap = getObjectValueCount(allToUsers || [], 'email');
    const ccUserMap = getObjectValueCount(allCcUsers || [], 'email');
    const possibleCCusers = getCCUsers(allCcUsers || [], toUserMap);
    const possibleBccUsers = getBccUsers(
      allBccUsers || [],
      toUserMap,
      ccUserMap
    );
    const attachments = [...state.template.attachments].map((att) => ({
      ...pick(att, ['fileName', 'fileSize', 'originalFileName'])
    }));
    const input = {
      parentConversationId:
        currentReplyThread?.parentConversationId ||
        currentReplyThread?.conversationId,
      toUsers: allToUsers ? allToUsers.map((to) => pick(to, ['email'])) : null,
      ccUsers: possibleCCusers.map((cc) => pick(cc, ['email'])),
      bccUsers: possibleBccUsers.map((bcc) => pick(bcc, ['email'])),
      content: rawContent,
      attachments: attachments || []
    };

    input.fromMailbox = {
      boxId: selectedMailBox?.boxId
    };
    composeEmail(input, resetState);
  };

  const updateCCState = (sec) => {
    switch (sec) {
      case 'cc':
        setShowCC(true);
        break;
      case 'bcc':
        setShowBCC(true);
        break;
      default:
        break;
    }
  };

  const getComposeSection = () => {
    const handleOnClick = () => {
      handlePageResize();
      setCompose(true);
    };

    if (compose) {
      return (
        <ComposeSectionHolder
          ref={editorContainerRef}
          className="position-relative"
        >
          <div className="pb10 divider ml-m-10 mr-m-10">
            {/* <div className="flex pl10 pt10 center ml-10 mb10">
              <Label className="mr-10">
                <FormattedMessage id="ticket.details.chat.from" />:
              </Label>
              <T2>{`${replyRecipients?.getVendorConversationReplyRecipients?.selectedMailbox?.outgoingAddress}`}</T2>
            </div> */}
            <div className="flex fx-sb actr pr-20">
              <div className="flex pl10 pt10 center ml-10 mb10">
                <div>
                  <FormattedMessage id="ticket.details.chat.from" />
                </div>
                {vendorConversationReplyRecipientsLoading ? (
                  <SpinnerContainer className="ml-10">
                    <Spinner size="small" />
                  </SpinnerContainer>
                ) : (
                  <>
                    <FromMailBoxSelector
                      allowEdit
                      mailBoxes={mailBoxes}
                      selectedMailBox={selectedMailBox}
                      mailBoxChangeHandler={mailBoxChangeHandler}
                    />
                    {!selectedMailBox?.outgoingDomainVerified && (
                      <Tippy
                        content={
                          <ToolTipContainer>
                            <FormattedMessage id="ticket.details.mailbox.email.unverified" />
                          </ToolTipContainer>
                        }
                        duration={250}
                        interactive
                        placement="right"
                        arrow={false}
                        allowHTML
                        appendTo={document.body}
                      >
                        <EmailStatus className="fx actr">
                          <SVGIcon
                            name="InlineError"
                            color="#ff0055"
                            size="sm"
                          />
                        </EmailStatus>
                      </Tippy>
                    )}
                  </>
                )}
              </div>

              <>
                <div className="flex actr gap-15">
                  {module === 'TICKET' && (
                    <AIComponent
                      editorRef={editorRef}
                      onCopy={onRephraseCopy}
                      type="REPHRASE"
                      prompts={AIPrompts || []}
                      data={{
                        Api: APPLY_AI_PROMPT,
                        accessorKey: 'applyAIPrompt'
                      }}
                      featureName="PROMPT_BUILDER"
                      hideButtonText
                      headingText={getTranslatedText(
                        intl,
                        'common.rephrased.text'
                      )}
                      headingIcon={'AIWand'}
                      loadingText={aiRephraseKeys?.loadingText}
                      successText={aiRephraseKeys?.successText}
                      copyButtonText={getTranslatedText(
                        intl,
                        'common.insert.text'
                      )}
                      copySuccessText={getTranslatedText(
                        intl,
                        'common.inserted'
                      )}
                      mixpanelEventOnClick={{
                        event:
                          'Rephrased with prompt - Ticket side conversation reply',
                        data: {
                          ticketId: workItemId
                        }
                      }}
                      mixpanelEventOnCopy={{
                        event:
                          'Copy and pasted rephrased content - Ticket side conversation reply',
                        data: {
                          ticketId: workItemId
                        }
                      }}
                    />
                  )}
                  <AccessControl
                    roleToCheck="sideConversationTemplate.view"
                    render={
                      <SideConversationTemplateButton
                        populateTemplate={populateTemplate}
                        className="mr-10"
                        workItemId={workItemId}
                        module={module}
                        selectedMailBox={selectedMailBox}
                      />
                    }
                  />
                </div>
              </>
            </div>

            {isMSP && (
              <div className="flex center pl10 mt-10 ml-10">
                <Label className="mr-10">
                  <FormattedMessage id="app.mail.recepients.to" />
                </Label>
                <MultipleNamesHandler
                  data={allToUsers.map((el) => {
                    return {
                      name: el.email
                    };
                  })}
                />
                <div className="flex mlauto mt-10">
                  <HiddenAction
                    updateState={updateCCState}
                    showField={showCC}
                    id="cc"
                  />
                  <HiddenAction
                    updateState={updateCCState}
                    showField={showBCC}
                    id="bcc"
                  />
                </div>
              </div>
            )}
            <div className="pl10">
              {showCC && (
                <div className="flex mt-10 ml-10 mr-10 fg1 center">
                  <SearchableEmailSelect
                    mailList={allCCUsers}
                    label="app.mail.recepients.cc"
                    placeholder={getTranslatedText(
                      intl,
                      'app.sideConversation.placeHolder.mail.recipients'
                    )}
                    updateChange={(item) => {
                      setCCUsers(item);
                    }}
                  />
                </div>
              )}
              {showBCC && (
                <div className="flex mt-10 ml-10 mr-10 fg1 center">
                  <SearchableEmailSelect
                    mailList={bccUsers}
                    label="app.mail.recepients.bcc"
                    placeholder={getTranslatedText(
                      intl,
                      'app.sideConversation.placeHolder.mail.recipients'
                    )}
                    updateChange={(item) => {
                      setBCCUsers(item);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <EditorHolder
            maxHeight={
              editorWidthIsSmall
                ? showCC
                  ? showBCC
                    ? '185px'
                    : '155px'
                  : '115px'
                : '90px'
            }
          >
            <Editor
              editorRef={editorRef}
              template={state.template}
              updateTemplate={updateTemplate}
              module={module || 'TICKET'}
              details={{
                workItem: {
                  workId: workItemId,
                  module: module
                }
              }}
              handleFileAttachments={handleFileAttachments}
              handleAttachmentsDeletion={handleAttachmentsDeletion}
              title="Add Attachments"
              description="Upload/drop files here"
              allowMultiple
              imageUploading={setIsImageUploading}
              toolbarSticky={false}
            />
          </EditorHolder>
          <ActionsButtons
            className="flex center action-buttons white-to-grey-bg"
            absolute={!editorWidthIsSmall}
          >
            <ButtonGroup>
              {!props.noNewConversation && (
                <Button plainSecondary onClick={() => setCompose(false)}>
                  <FormattedMessage id="common.cancel" />
                </Button>
              )}
              <Button
                loading={loading}
                primary
                disabled={
                  !selectedMailBox?.outgoingDomainVerified || isImageUploading
                }
                onClick={composeMail}
                icon={<SVGIcon name="SendWhite" color={COLOR_MAP.white} />}
              >
                <FormattedMessage id="app.actions.send" />
              </Button>
            </ButtonGroup>
          </ActionsButtons>
        </ComposeSectionHolder>
      );
    }

    return (
      <ActionToolbar
        intl={intl}
        onClick={handleOnClick}
        emailSignature={emailSignature}
        createNewSideConversation={createNewSideConversation}
        toUser={allToUsers?.[0] || {}}
        modalOnly={modalOnly}
        toggleNewSideConversation={toggleNewSideConversation}
      />
    );
  };

  const authors = [];
  const chatfeeds = conversations.map((convo) => {
    const { content, user } = convo;
    const userType = convo?.type === 'TECH_EMAIL' ? 'sender' : 'receiver';
    if (!authors.some((el) => el.authorId === user?.userId)) {
      authors.push({
        name: user ? `${user.firstName} ${user.lastName}` : 'System',
        authorId: user?.userId || 'system'
      });
    }

    return {
      ...convo,
      user: user,
      isSend: false,
      message: content,
      userType: userType,
      authorId: user?.userId || 'system'
    };
  });

  return (
    <Wrapper className="full-width full-height">
      <ReplyThreadWrapper className="full-height">
        {allConversationsLoading ? (
          <Loader />
        ) : (
          <>
            <Convos className="overflow-auto">
              {chatfeeds.length > 0 ? (
                <ChatFeed
                  ref={conversationcontainerRef}
                  customChatBubble={(props) => (
                    <SideConversationBubble
                      {...props}
                      intl={intl}
                      module={module}
                      company={company}
                      workItemId={workItemId}
                      readOnly={readOnly}
                      backgroundThreadConversation={
                        backgroundThreadConversation
                      }
                      sentMessageData={sentMessageData}
                      updateConversationsFromSocket={
                        updateConversationsFromSocket
                      }
                    />
                  )}
                  messages={chatfeeds}
                  authors={authors}
                  yourAuthorId={loggedInUser.userId}
                />
              ) : (
                <EmptyStateHolder>
                  <NoDataCard
                    imageURL={`url(${envConfig.imageRoot}svg/updates-empty-state.svg)`}
                    text={
                      <FormattedMessage id="ticket.details.updates.emptyState" />
                    }
                    description={
                      <FormattedMessage id="ticket.details.updates.emptyState.description" />
                    }
                    type="secondary"
                  />
                </EmptyStateHolder>
              )}
            </Convos>
            {isEditAuthorised &&
              (conversationUXFlag ? (
                <>
                  <ComposeNew
                    module={module}
                    workItem={{
                      workId: workItemId,
                      module: module,
                      subject: props?.workItem?.subject
                    }}
                    parentConversationId={
                      currentReplyThread?.parentConversation?.conversationId ||
                      currentReplyThread?.conversationId
                    }
                    toUser={allToUsers?.[0] || {}}
                    emailSignature={emailSignature}
                    toggleNewSideConversation={toggleNewSideConversation}
                    isNewSideConversationDisabled={
                      isNewSideConversationDisabled
                    }
                    newSideConversationLoading={newSideConversationLoading}
                  />
                </>
              ) : (
                getComposeSection()
              ))}
          </>
        )}
      </ReplyThreadWrapper>
    </Wrapper>
  );
}

export { ChatThreadContainer };
